(() => {
  const mediaSelector = '[data-deferred-src], [data-deferred-srcset]';
  const roots = Array.from(document.querySelectorAll('[data-deferred-media-root]'));

  const hydrate = (root) => {
    root.querySelectorAll(mediaSelector).forEach((node) => {
      if (node.dataset.deferredSrcset) {
        node.srcset = node.dataset.deferredSrcset;
        delete node.dataset.deferredSrcset;
      }

      if (node.dataset.deferredSrc) {
        node.src = node.dataset.deferredSrc;
        delete node.dataset.deferredSrc;
      }
    });
  };

  if (!roots.length) return;

  const intentOptions = { once: true, passive: true };
  roots.forEach((root) => {
    ['pointerenter', 'focusin', 'touchstart'].forEach((eventName) => {
      root.addEventListener(eventName, () => hydrate(root), intentOptions);
    });
  });

  if (!('IntersectionObserver' in window)) {
    roots.forEach(hydrate);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        hydrate(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '600px 0px' }
  );

  roots.forEach((root) => observer.observe(root));
})();
